<template v-model="visible" v-if="visible">
  <div class="mask maskon" v-if="visible">
    <div class="tsk tsk_tc">
      <div class="hd">
        <h2 class="t_cap">{{title}}</h2>
      </div>
      <div class="bd">
        <div class="d t_info">
          <p v-if="cnt">{{cnt}}</p>
          <input type="text" class="inp_ts" v-model="pwd" :placeholder="placeholder" />
        </div>
        <div class="d t_btn">
          <p class="btn4 btn4_qx" @click="close">取消</p>
          <p class="btn4 btn4_qd" @click="confirm">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from "vue";
export default {
  name: 'tMessage',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "请输入新密码",
    },
    cnt: {
      type: String,
      default: "",
    },
    handler: {
      type: Function,
    },
    handlerClose: {
      type: Function,
    },
    placeholder: {
      type: String,
      default: "请输入新密码",
    }
  },
  setup(props) {
    const state = reactive({
      visible: props.visible,
      pwd: "",
      title: props.title,
    });

    const confirm = () => {
      const { pwd } = state;
      const { handler } = props;
      const value = pwd;
      state.pwd = "";
      handler(value);
    };
    const close = () => {
        const {handlerClose} = props;
      handlerClose();
    };

    return {
      ...toRefs(state),
      confirm,
      close,
    };
  },
};
</script>
<style lang="less" scoped>
.tsk_tc .hd {
  display: block;
}
.tsk .hd {
    height: 3.37rem;
    text-align: center;
    display: flex;
    justify-content: center;
}
.tsk_tc .t_info {
  padding-top: 0.21rem;
}
</style>
